module.exports = __webpack_public_path__ + "img/partners15.89b64ff6.jpg";